import { pdkAxios } from '@/lib/pdk-axios.ts';
import { confirmationsStore } from '@/models/stores/confirmations.ts';
import {
  type ConfirmationField,
  ConfirmationTargetType,
} from '@/models/types.ts';
import { useMutation } from '@tanstack/react-query';

type ConfirmationInput = {
  id: string;
  targetId: string;
  targetType: ConfirmationTargetType;
  field: ConfirmationField;
  confirmed: boolean;
  isManuallyToggled?: boolean;
  value?: string;
};

export function useUpdateConfirmationMutation() {
  const updateConfirmationMutation = useMutation({
    mutationFn: async (input: ConfirmationInput) => {
      const response = await pdkAxios.post('/confirmations/confirm', {
        id: input.id,
        target_type: input.targetType,
        target_id: input.targetId,
        field_key: input.field,
        confirmed: input.confirmed,
        is_manually_toggled: input.isManuallyToggled,
        value: input.value,
      });
      return response.data;
    },

    onMutate: async (input) => {
      const { id, targetId, targetType, field, confirmed } = input;
      const prev = confirmationsStore.getByTargetAndField(
        targetId,
        targetType,
        field,
      )?.confirmed;

      if (confirmed) {
        confirmationsStore.setConfirmed({
          id,
          targetId,
          targetType,
          field,
        });
      } else {
        confirmationsStore.clearConfirmed(targetId, targetType, field);
      }

      return { prev };
    },

    onError: (_err, input, ctx) => {
      if (ctx?.prev) {
        confirmationsStore.setConfirmed({
          id: input.id,
          targetId: input.targetId,
          targetType: input.targetType,
          field: input.field,
        });
      } else {
        confirmationsStore.clearConfirmed(
          input.targetId,
          input.targetType,
          input.field,
        );
      }
    },
  });

  return { updateConfirmationMutation };
}
